import { StyleSheet } from 'react-native';

export const categoryStyles = StyleSheet.create({
  wrapper: {
    marginHorizontal: 8,
    marginVertical: 10,
  },
  topImage: {
    height: 70,
    width: 70,
    borderRadius: 10,
    position: 'relative',
    marginHorizontal: 5,
    backgroundColor: '#808080',
  },
  topText: {
    bottom: 5,
    left: 7,
    marginLeft: 5,
    color: 'black',
    fontSize: 12,
  },
});
